// extracted by mini-css-extract-plugin
module.exports = {"image":"Category_image__2UyIs","link":"Category_link__2mT5x","withoutThumbnail":"Category_withoutThumbnail__o_h0D"};